module.exports = __webpack_public_path__ + "img/remove.e401a5c6.svg";